import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 14 22'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path fill='currentColor' d='M6.998 0 .5 11.204l6.498-3.069zM6.998 8.136.5 11.205l6.498 3.992z' />
    <path fill='currentColor' d='M13.496 11.204 6.997 0v8.135z' />
    <path fill='currentColor' d='m6.997 15.197 6.499-3.992-6.499-3.07zM.5 12.484 6.998 22v-5.526z' />
    <path fill='currentColor' d='M6.997 16.474V22l6.502-9.516z' />
  </svg>
)
export default SvgComponent
